'use strict';

angular.module('amexReconciliationApp')
  .service('FeatureFlagRepository',
    function FeatureFlagRepository($resource) {
      var self = this;

      self.getFeatureFlags = function () {

        var featureFlagsResource = $resource('/api/v1/featureFlags');

        return featureFlagsResource.get().$promise;
      };

    });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/FeatureFlagRepository.js
// module id = 609
// module chunks = 0